import { Avatar } from 'antd'
import { FC } from 'react'
import { BitazzaText } from '../../../../components'
import { getAvatarImage } from '../../../../util/getAvatar'
import Styles from './Badges.module.scss'

interface Props {
    type: string
    name?: string
    rank?: number | string
    highlighted?: boolean
    bolderAvatar?: boolean
    big?: boolean
    userRank?: boolean
    table?: boolean
    color?: string
    onClick?: () => void
    seasonSummery?: boolean
}

export const Badges: FC<Props> = ({
    type,
    name,
    rank,
    highlighted,
    bolderAvatar,
    big,
    userRank,
    table,
    color,
    onClick,
    seasonSummery,
}) => {
    return (
        <div className={Styles.container} onClick={onClick}>
            <Avatar
                shape="square"
                size={
                    table
                        ? 42
                        : seasonSummery && big && highlighted
                        ? 140
                        : seasonSummery
                        ? 148
                        : userRank
                        ? 58
                        : big && highlighted
                        ? 130
                        : big
                        ? 100
                        : bolderAvatar
                        ? 82
                        : highlighted
                        ? 76
                        : 66
                }
                icon={
                    <img
                        src={getAvatarImage(type)}
                        alt="avatar"
                        style={{
                            position: 'relative',
                            zIndex: 2,
                            top: 0,
                        }}
                    />
                }
            />
            {name && rank ? (
                <>
                    <BitazzaText content={name} color="#fff" format="t16" />
                    <BitazzaText
                        strong
                        content={rank}
                        format="t20"
                        color={color}
                    />
                </>
            ) : null}
        </div>
    )
}
